import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {Message} from 'primeng/components/common/api';

import {AwsService} from "./aws.service";

@Component({
    template: require('./forgot.component.pug'),
    styles: [require('./forgot.component.css')]
})
export class ForgotComponent implements OnInit, AfterViewInit {
    msgs: Message[] = [];

    email: string;
    password: string;

    returnUrl: string;

    constructor(private _route: ActivatedRoute, private _router: Router, private _awsService: AwsService) {
    }

    ngOnInit(): void {
        this.returnUrl = this._route.snapshot.paramMap.get("returnUrl");
        if (!this.returnUrl) this.returnUrl = '/';
    }

    async ngAfterViewInit() {
        const result = await this._awsService.refresh();
        if (result) this._router.navigate([this.returnUrl]);
    }

    async signIn() {
        this.msgs = [];
        try {
            const result = await this._awsService.authenticate(this.email, this.password);
            if (result) this._router.navigate([this.returnUrl]);
        } catch (err) {
            console.error(err);
            this.msgs.push({severity:'error', summary:'Este Email no existe en nuestro sistema'});
        }
    }

    async sendEmail() {
        
    }


}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/forgot.component.ts